/* eslint-disable */
import * as registry from '../registry.js'
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ count: NonNullable<unknown> }} Plan_Duration_MonthsInputs */

const en_plan_duration_months = /** @type {(inputs: Plan_Duration_MonthsInputs) => LocalizedString} */ (i) => {const countPlural = registry.plural("en", i?.count, {});
	if (countPlural === "one") return /** @type {LocalizedString} */ (`${i?.count} month`);
	if (countPlural === "other") return /** @type {LocalizedString} */ (`${i?.count} months`);
	return /** @type {LocalizedString} */ ("plan_duration_months");
};

const es_plan_duration_months = /** @type {(inputs: Plan_Duration_MonthsInputs) => LocalizedString} */ (i) => {const countPlural = registry.plural("es", i?.count, {});
	if (countPlural === "one") return /** @type {LocalizedString} */ (`${i?.count} mes`);
	if (countPlural === "other") return /** @type {LocalizedString} */ (`${i?.count} meses`);
	return /** @type {LocalizedString} */ ("plan_duration_months");
};

/**
* | countPlural | output |
* | --- | --- |
* | "one" | "{count} month" |
* | "other" | "{count} months" |
*
* @param {Plan_Duration_MonthsInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const plan_duration_months = /** @type {((inputs: Plan_Duration_MonthsInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Plan_Duration_MonthsInputs, { locale?: "en" | "es" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_plan_duration_months(inputs)
	return en_plan_duration_months(inputs)
});